import React from 'react';
import PropTypes from 'prop-types';
import MobileHeader from 'pages/mobileHeader';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import { Components, Utils, translate } from 'versafleet-core';
import NotificationModule from 'modules/notification';

class NotificationPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: this._getDefaultFilter(),
    };
  }

  UNSAFE_componentWillMount() {
    this._loadList();
  }

  componentDidUpdate(_prevProps, prevState) {
    if (prevState.filter !== this.state.filter) {
      this._loadList();
    }
  }

  _loadList(page = 1) {
    Utils.FullScreenLoading.FullScreenLoadingManager.open(
      this.props.strings.Notification.loadingItems,
    );
    this.props.dispatch(ReduxActions.notification.fetchList({
      ...this.state.filter,
      page,
    }))
      .then(() => {
        Utils.FullScreenLoading.FullScreenLoadingManager.close();
      })
      .then(() => {
        this.props.dispatch(ReduxActions.notification.resetNewCount());
      });
  }

  _getDefaultFilter = () => ({
    date: Utils.DateHelper.today(),
    page: 1,
    per_page: 20,
  });

  _onFilterChange(fieldName, value) {
    if (fieldName === 'date' && (
      Utils.Helper.isNullOrUndefined(value) || !Utils.Helper.isNonEmptyString(value)
    )) {
      return;
    }

    const newFilter = Utils.Helper.setFilter(this.state.filter, fieldName, value);
    this._updateFilters(newFilter);
  }

  _updateFilters(filter) {
    this.setState({ filter });
  }

  _renderActionPanel() {
    return (
      <Components.Mobile.ActionPanel className="vf-mobile-notification-page__action-panel">
        <div className="vf-mobile-notification-page__action-panel__content">
          <Components.Paginator
            className="vf-mobile-notification-page__action-panel__content__paginator"
            currentPage={this.props.meta.page}
            id="vf-mobile-notification-page__paginator"
            isCountCustomizable
            itemsPerPage={this.props.meta.per_page}
            model="notifications"
            onChange={(key, val) => this._onFilterChange(key, val)}
            totalItems={this.props.meta.total}
          />
          <Components.Input.DatePicker
            id="vf-mobile-notification-page__datepicker"
            onChange={val => this._onFilterChange('date', val)}
            value={this.state.filter.date}
          />
        </div>
      </Components.Mobile.ActionPanel>
    );
  }

  render() {
    return (
      <div className="vf-mobile-notification-page">
        <MobileHeader
          id="vf-mobile-notification-page__mobile-header"
          shouldRenderSearch={false}
          title="Notifications"
        />
        <div>
          {this._renderActionPanel()}
        </div>

        {this.props.notifications.map(n => (
          <NotificationModule.Mobile.LineItem
            data={n}
            id="vf-mobile-notification-page__line-item"
            key={`notification-${n.id}`}
          />
        ))}
      </div>
    );
  }
}

NotificationPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  meta: PropTypes.shape(),
  notifications: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
  })),
  strings: PropTypes.shape({
    Notification: PropTypes.shape({
      loadingItems: PropTypes.string,
    }),
  }).isRequired,
};

NotificationPage.defaultProps = {
  meta: {},
  notifications: [],
};

function mapStateToProps(state) {
  const { notification } = state;
  return {
    notifications: notification.notifications,
    meta: notification.notificationMeta,
  };
}

export default connect(mapStateToProps)(translate('')(NotificationPage));
